module.exports = __webpack_public_path__ + "img/stripe.87fe0d5.png";